var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4843 20.6878C25.0658 18.5346 26 15.8764 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26C15.8772 26 18.536 25.0653 20.6895 23.483L20.6878 23.4843C20.7468 23.5643 20.8125 23.6409 20.8849 23.7133L28.5858 31.4142C29.3668 32.1953 30.6332 32.1953 31.4142 31.4142C32.1953 30.6332 32.1953 29.3668 31.4142 28.5858L23.7133 20.8849C23.6409 20.8125 23.5643 20.7468 23.4843 20.6878ZM24 13C24 19.0751 19.0751 24 13 24C6.92487 24 2 19.0751 2 13C2 6.92487 6.92487 2 13 2C19.0751 2 24 6.92487 24 13Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.27f5d54b9e766bf3113f2a5fb8b0e47d.svg";
export { ForwardRef as ReactComponent };